import Accordion from './Accordion'
export { Accordion }
export default Accordion
